import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24d06ed1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "modal_back"
}
const _hoisted_2 = { id: "select_modal" }
const _hoisted_3 = {
  class: "option-checkbox",
  style: {"height":"100%"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "graph-footer-wrapper" }
const _hoisted_6 = { class: "graph-footer" }
const _hoisted_7 = { class: "footer-left" }
const _hoisted_8 = { class: "station_color" }
const _hoisted_9 = {
  width: "25",
  height: "25"
}
const _hoisted_10 = { key: 0 }

import { ref, watch } from 'vue'
import { GraphColor } from '@/lib/graph/types/initResult'

export type Option = {
  value: string
  label?: string
  color?: string
}

type MultiSelectModalProps = {
  modal: boolean
  options: Option[]
  maxSelectNum: number
  selected: Option[]
  emptyMessage?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modal: { type: Boolean },
    options: null,
    maxSelectNum: null,
    selected: null,
    emptyMessage: null
  },
  emits: ['update:selected', 'update:modal'],
  setup(__props: any, { emit }) {

const props = __props as {
  modal: boolean
  options: Option[]
  maxSelectNum: number
  selected: Option[]
  emptyMessage?: string
}



const selected = ref<Option[]>(props.selected)

const change = (select: Option) => {
  const index = selected.value.findIndex(s => s.value === select.value)
  const length = selected.value.length

  if (index < 0) {
    // 追加
    if (length === props.maxSelectNum) {
      alert(`最大で${props.maxSelectNum}個まで選択可能です`)

      return
    }

    const currentColors = selected.value.map(s => s.color)
    const color = GraphColor.find(c => !currentColors.includes(c))

    select.color = color

    selected.value = [...selected.value, select]
  } else {
    // 削除
    selected.value.splice(index, 1)
    selected.value = [...selected.value]
  }
}

const getColor = (value: string) => {
  const found = selected.value.find(s => s.value === value)

  return found?.color
}

const submitStations = () => {
  emit('update:modal', false)
  emit('update:selected', selected.value)
}

const showModal = () => {
  emit('update:modal', true)
}

watch(
  () => props.options,
  () => {
    selected.value = props.options.slice(0, 8).map((s, index) => {
      s.color = GraphColor[index]

      return s
    })

    emit('update:selected', selected.value)
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.modal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (o) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (change(o)),
                  key: o.value,
                  style: _normalizeStyle({ opacity: getColor(o.value) ? '1' : '0.5' })
                }, [
                  _createElementVNode("div", {
                    class: "station_color",
                    style: _normalizeStyle({ backgroundColor: getColor(o.value) })
                  }, null, 4),
                  _createTextVNode(" " + _toDisplayString(o.label), 1)
                ], 12, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("button", {
              onClick: submitStations,
              id: "submit"
            }, "決定")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selected.value, (s) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "station",
              key: s.value,
              onClick: showModal
            }, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                  _createElementVNode("rect", {
                    width: "25",
                    height: "25",
                    style: _normalizeStyle({ fill: s.color })
                  }, null, 4)
                ]))
              ]),
              _createTextVNode(" " + _toDisplayString(s.label), 1)
            ]))
          }), 128)),
          (selected.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.emptyMessage || '選択肢が存在しません'), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})